import {
  type UpdateUserMutationVariables,
  useUpdateUserMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useUpdateUser = () => {
  const [updateUserMutation, { error }] = useUpdateUserMutation({
    context: {
      apiVersion: AppApiVersions.core,
    },
  });

  const updateUser = (variables: UpdateUserMutationVariables) =>
    updateUserMutation({
      variables,
    });

  return {
    updateUser,
    userUpdateError: error,
  };
};
